<template>
  <div
    class="product-details-delivery-date-simple product-details-delivery-date-simple--truck delivery-banner-made-pdp"
    id="js-made-product-details-delivery-dates-simple-container"
    :data-product-id="productId"
    :data-selected-color="color"
    data-nosnippet
  >
  <div
    class="product-details-delivery-date-simple__loading product-details-delivery-date-simple__loading--truck js-made-product-details-delivery-dates-simple-spinner shown"
  >
    <span class="product-details-delivery-date-simple__loading-text product-details-delivery-date-simple__loading-text--truck">
      Calculating your
      <span class="product-details-delivery-date-simple__loading-text-highlight">
        earliest delivery date
      </span>
    </span>

    <div class="product-details-delivery-date-simple__spinner product-details-delivery-date-simple__spinner--truck">
      <!-- Start Icon -->
      <UseSvg
        icon="box-jiffy-packed"
        class="product-details-delivery-date-simple__track-icon"
      />

      <!-- Track -->
      <div class="product-details-delivery-date-simple__track">
        <!-- Static track path -->
        <div class="product-details-delivery-date-simple__track-path">
          <div
            v-for="index in dashesQuantity"
            :key="`dash-${index}`"
            class="product-details-delivery-date-simple__track-dash"
          />
        </div>

        <!-- Animated track path with truck -->
        <div class="product-details-delivery-date-simple__track-path product-details-delivery-date-simple__track-path--passed">
          <div
            v-for="index in dashesQuantity"
            :key="`passed-dash-${index}`"
            class="product-details-delivery-date-simple__track-dash product-details-delivery-date-simple__track-dash--passed"
          />
          <UseSvg
            icon="fast-delivery"
            class="product-details-delivery-date-simple__truck"
          />
        </div>
      </div>

      <!-- End Icon -->
      <UseSvg
        icon="marker-pin"
        class="product-details-delivery-date-simple__track-icon"
      />
    </div>
  </div>
  <div class="product-details-delivery-date-simple__wrapper product-details-delivery-date-simple__wrapper--truck js-made-product-details-delivery-dates-simple-wrapper hidden">
    <div class="product-details-delivery-date-simple__banner">
      CUSTOM SHIRTS. <span class="product-details-delivery-date-simple__banner-highlight">FAST</span>.
    </div>

    <div class="product-details-delivery-date-simple__delivery-container">
      <div class="product-details-delivery-date-simple__delivery product-details-delivery-date-simple__delivery--truck js-product-details-delivery-dates-simple-shipment">
        <UseSvg
          icon="box-jiffy-check"
          class="product-details-delivery-date-simple__delivery-icon product-details-delivery-date-simple__delivery-icon--truck"
        />
        <span class="product-details-delivery-date-simple__delivery-date-label product-details-delivery-date-simple__delivery-date-label--truck">
          Get it
          <span class="product-details-delivery-date-simple__delivery-date-label-value js-made-product-details-delivery-dates-simple-direct-value"></span>
        </span>
      </div>

      <div class="product-details-delivery-date-simple__cutoff product-details-delivery-date-simple__cutoff--truck js-product-details-delivery-dates-simple-cutoff-wrapper">
        If ordered in
        <b class="product-details-delivery-date-simple__cutoff-date product-details-delivery-date-simple__cutoff-date--truck js-made-product-details-delivery-dates-simple-cutoff" data-countdown-mode="short" data-countdown="">...</b>
      </div>
    </div>

    <hr class="product-details-delivery-date-simple__separator">

    <div class="product-details-delivery-date-simple__shipping-info">
      <span class="product-details-delivery-date-simple__shipping-text">
        <span class="product-details-delivery-date-simple__shipping-highlight">FREE SHIPPING</span> at
        <span class="product-details-delivery-date-simple__shipping-price js-made-product-details-delivery-dates-simple-free-shipping-value">...</span>
      </span>
      <UseSvg
        icon="ellipse"
        class="product-details-delivery-date-simple__ellipse-icon"
      />
      <span class="product-details-delivery-date-simple__shipping-note">
        No Hidden Rush Fees
      </span>
    </div>

    <hr class="product-details-delivery-date-simple__separator">

    <div class="product-details-delivery-date-simple__features">
      <div class="product-details-delivery-date-simple__feature">
        <div class="product-details-delivery-date-simple__feature-icon">
          <UseSvg
            icon="check-circle"
            class="product-details-delivery-date-simple__feature-check"
          />
        </div>
        <span class="product-details-delivery-date-simple__feature-text">Premium print quality</span>
      </div>
      <div class="product-details-delivery-date-simple__feature">
        <div class="product-details-delivery-date-simple__feature-icon">
          <UseSvg
            icon="check-circle"
            class="product-details-delivery-date-simple__feature-check"
          />
        </div>
        <span class="product-details-delivery-date-simple__feature-text">Unlimited print colors</span>
      </div>
      <div class="product-details-delivery-date-simple__feature product-details-delivery-date-simple__feature--desktop">
        <div class="product-details-delivery-date-simple__feature-icon">
          <UseSvg
            icon="check-circle"
            class="product-details-delivery-date-simple__feature-check"
          />
        </div>
        <span class="product-details-delivery-date-simple__feature-text">Vibrant &amp; long lasting</span>
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import UseSvg from 'common/vue/components/UseSvg.vue';
import initMadeDates from 'components/jiffy/product-details-delivery-date-simple/init-made-dates';

const props = defineProps({
  productId: {
    type: String,
    default: null
  },
  color: {
    type: String,
    required: true
  },
  compositionId: {
    type: Number,
    required: true
  }
});

const dashesQuantity = ref(10);

const getDeliveryDate = () => {
  window.jiffy_made_product_props = {
    composition_id: props.compositionId,
  };
  initMadeDates();
};

onMounted(() => {
  getDeliveryDate();
});

watch(() => props.compositionId, () => {
  getDeliveryDate();
});
</script>
